module.exports = __webpack_public_path__ + "img/btn_sound-on.191fa025.png";